/**
 * rechartsTheme — the chrome every Recharts chart in the kit shares.
 *
 * Recharts writes these straight onto SVG attributes and inline styles, where `var(--x)`
 * resolves, so one value is correct in both themes and no chart needs to re-read tokens
 * to draw its own axes. Series colours are NOT here: those are the caller's, and several
 * of them (RAG, the validated 5-slot categorical palette) are server truth or a signed-off
 * palette rather than chrome.
 *
 * Grid is hairline and SOLID. Dashed rules carry meaning in this app — a target
 * threshold, a delivered/open divider — so the grid must not compete with them.
 */

export const gridStroke = 'var(--line2)'

/** Axis ticks: muted ink, no tick marks, and the axis line only where it is the baseline. */
export const axisStyle = {
  tick: { fontSize: 10, fill: 'var(--mut2)', fontFamily: 'JetBrains Mono' },
  tickLine: false,
  axisLine: { stroke: 'var(--line)' },
} as const

export const tooltipStyle = {
  background: 'var(--panel)',
  border: '1px solid var(--line)',
  borderRadius: 8,
  fontSize: 11,
  color: 'var(--ink)',
  boxShadow: 'var(--shadow)',
} as const
